/**
 * Builds a download filename from a report/document title: filesystem-hostile
 * characters and whitespace runs collapse to underscores.
 *
 * @param title - Human-readable title
 * @returns Sanitized `<title>.pdf` filename
 */
export function toPdfFilename(title: string): string {
  return `${title.replace(/[\\/:*?"<>|]+/g, '_').replace(/\s+/g, '_')}.pdf`;
}

/**
 * Downloads a PDF from an S3 signed URL
 *
 * @param url - S3 signed URL for the PDF
 * @param filename - Filename for the download
 * @returns Promise that resolves when download is complete
 */
export async function downloadPdfFromUrl(url: string, filename: string): Promise<void> {
  if (!url || !url.trim()) {
    throw new Error('Invalid PDF URL');
  }

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to download PDF');
  }

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the blob URL
  window.URL.revokeObjectURL(blobUrl);
}
